import React from 'react';
import './Offers.css';

import { Heading, Offer } from '../../../components';
import { offers } from '../../../constants';



const Offers = () => {  
  return (

      <section className='offers'>

        {/* Section heading */}
        <Heading title={'Special Offers'} subTitle={'Exclusive Deals'} />

        <div className="box-container">
          {offers.slice(0, 2).map((offer) => (
            <Offer key={offer.id} offer={offer} />
          ))}
        </div>

      </section>
  );
}

export default Offers;